import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  LinearProgress,
  Modal,
  Typography,
} from "@mui/material";
import { ReactNode } from "react";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 1,
  display: "flex",
  flexDirection: "column",
};

const styleBatch = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  display: "flex",
  flexDirection: "column",
};

interface ModalProps {
  isLoading: boolean;
  open: boolean;
  header: string;
  body: string | ReactNode;
  body2?: string;
  isError?: boolean;
  leftButtonText: string;
  rightButtonText: string;
  leftButtonDisabled?: boolean;
  rightButtonDisabled?: boolean;
  rightButtonVariant?: "text" | "outlined" | "contained";
  leftButtonVariant?: "text" | "outlined" | "contained";
  errorTitle?: string;
  errorMessage?: string;
  leftButtonColor:
    | "inherit"
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning";
  rightButtonColor:
    | "inherit"
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning";
  handleLeftButton: any;
  handleRightButton: any;
  handleClose: () => void;
  type?: string;
  children?: React.ReactNode;
  isLeftButtonLoading?: boolean;
  isRightButtonLoading?: boolean;
}

export default function ConfirmationModal(props: ModalProps) {
  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      {props.isLoading ? (
        loadingModal()
      ) : (
        <>{props.isError ? errorModal(props) : baseModal(props)}</>
      )}
    </Modal>
  );
}

function errorModal(props: ModalProps) {
  const errorTitle = props.errorTitle ? props.errorTitle : "Error";
  const errorMessage = props.errorMessage
    ? props.errorMessage
    : "An error occurred while processing the request.";

  return (
    <Card sx={style}>
      <CardHeader title={errorTitle}></CardHeader>
      <CardContent>
        <Alert severity="error">{errorMessage}</Alert>
        {props?.children}
      </CardContent>
      <CardActions style={{ justifyContent: "flex-end", flexGrow: 1 }}>
        <Button
          onClick={props.handleClose}
          variant="outlined"
          color="primary"
          size="small"
        >
          Close
        </Button>
      </CardActions>
    </Card>
  );
}

function baseModal(props: ModalProps) {
  return (
    <Card sx={style}>
      {props.type == "Batch" ? (
        <>
          <CardHeader
            title={props.header}
            subheader={props.body}
            sx={{ paddingBottom: 0 }}
          />

          {props?.children}
          <CardContent>
            <Typography
              id="modal-modal-description"
              variant="body1"
              color="rgba(0, 0, 0, 0.60)"
            >
              <b> {props.body2}</b>
              <br />
            </Typography>
          </CardContent>
          <Divider />
        </>
      ) : (
        <CardContent>
          <Typography variant="h5" component="h5">
            {props.header}
          </Typography>
          <Typography
            id="modal-modal-description"
            sx={{ mt: 2 }}
            variant="body2"
          >
            {props.body}
          </Typography>
          {props?.children}
        </CardContent>
      )}

      <Divider />
      <CardActions style={{ justifyContent: "flex-end", flexGrow: 1 }}>
        <LoadingButton
          disabled={props.leftButtonDisabled ? props.leftButtonDisabled : false}
          onClick={props.handleLeftButton}
          variant={props.leftButtonVariant}
          color={props.leftButtonColor}
          size="small"
          loading={props.isLeftButtonLoading}
        >
          {props.leftButtonText}
        </LoadingButton>
        <LoadingButton
          disabled={
            props.rightButtonDisabled ? props.rightButtonDisabled : false
          }
          onClick={props.handleRightButton}
          variant={props.rightButtonVariant}
          color={props.rightButtonColor}
          size="small"
          loading={props.isRightButtonLoading}
        >
          {props.rightButtonText}
        </LoadingButton>
      </CardActions>
    </Card>
  );
}
function loadingModal() {
  return (
    <Card sx={style}>
      <CardHeader title="Processing"></CardHeader>
      <CardContent style={{ justifyContent: "center" }}>
        <LinearProgress />
        <Typography sx={{ mt: 2 }} variant="body2">
          Please wait while your request is being processed.
        </Typography>
      </CardContent>
    </Card>
  );
}
